CustomTC.define('jquery/css/var/rmargin',[],function() {
	return (/^margin/);
});

